import { useTranslation } from "react-i18next";

import type { WebhookSubscription } from "../api/types";

import { Badge } from "@/components/ui/v2/badge";
import { formatTimestamp } from "@/lib/helpers/formatDate";
import { TableColumn } from "@/types/table/tableProps";

export function useWebhookSubscriptionColumns(): TableColumn<WebhookSubscription>[] {
  const { t } = useTranslation();

  return [
    {
      width: "35%",
      header: t("webhooks.subscriptions.url"),
      accessor: "url",
      Cell: (item) => (
        <span className="font-mono text-sm truncate block max-w-xs" title={item.url}>
          {item.url}
        </span>
      ),
    },
    {
      width: "25%",
      header: t("webhooks.subscriptions.eventTypes"),
      accessor: "eventTypes",
      sortable: false,
      Cell: (item) => (
        <div className="flex flex-wrap gap-1">
          {item.eventTypes.map((eventType) => (
            <Badge key={eventType} variant="secondary" size="small">
              {eventType}
            </Badge>
          ))}
        </div>
      ),
    },
    {
      width: "15%",
      header: t("common.status"),
      accessor: "isActive",
      Cell: (item) => (
        <Badge variant={item.isActive ? "success" : "neutral"} size="medium">
          {item.isActive ? t("common.active") : t("common.inactive")}
        </Badge>
      ),
    },
    {
      width: "25%",
      header: t("common.createdDate"),
      accessor: "createdDate",
      Cell: (item) => (
        <span className="text-sm text-muted-foreground">
          {formatTimestamp(item.createdDate)}
        </span>
      ),
    },
  ];
}
